import { ErrorMessage } from '@hookform/error-message'
import { CustomModal } from 'components'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { fetchNewVideoAction } from 'store/action/videoReducer'

function FetchNewVideo({ isOpenNewVideoModal, onClose, type }) {
   const settingData = useSelector((state) => state.settings)
   const { selectedChannelID } = settingData
   const videoReduxData = useSelector((state) => state.videoRedux)
   const { isFetchVideo, fetchVideoLoading } = videoReduxData
   const [startDate, setStartDate] = useState()
   const [endDate, setEndDate] = useState(new Date())
   const method = useForm()
   const {
      register,
      formState: { errors },
      handleSubmit,
      setValue,
      setError,
      clearErrors
   } = method
   const dispatch = useDispatch()

   register('start_date', { required: { value: true, message: 'Please select start date' } })
   register('end_date', { required: { value: true, message: 'Please select end date' } })

   const onSubmit = (data) => {
      dispatch(fetchNewVideoAction({ channel_id: selectedChannelID, ...data }))
   }

   useEffect(() => {
      if (isFetchVideo) {
         onClose()
      }
      return () => {}
   }, [isFetchVideo])

   useEffect(() => {
      setValue('end_date', dayjs(new Date()).format('YYYY-MM-DD'))
      return () => {}
   }, [])

   const calculateDate = (period) => {
      switch (period) {
         case '3Months':
            return dayjs().subtract(3, 'month').startOf('day').format('YYYY-MM-DD')
         case '6Months':
            return dayjs().subtract(6, 'month').startOf('day').format('YYYY-MM-DD')
         case '1Year':
            return dayjs().subtract(1, 'year').startOf('day').format('YYYY-MM-DD')
         default:
            return null
      }
   }

   return (
      <div>
         <CustomModal
            show={isOpenNewVideoModal}
            title={'Fetch Video'}
            closeModal={onClose}
            centered
            backdrop="static">
            <div className="pt-0">
               <form>
                  <div className="fe-video d-flex mb-2">
                     <button
                        type="button"
                        onClick={() => {
                           const startDate = calculateDate('3Months')
                           dispatch(
                              fetchNewVideoAction({
                                 channel_id: selectedChannelID,
                                 start_date: startDate,
                                 end_date: dayjs().format('YYYY-MM-DD')
                              })
                           )
                        }}
                        className="channel-btn"
                        disabled={fetchVideoLoading}>
                        <span>Last 3 Month</span>
                     </button>
                     <button
                        type="button"
                        className="channel-btn"
                        disabled={fetchVideoLoading}
                        onClick={() => {
                           const startDate = calculateDate('6Months')
                           dispatch(
                              fetchNewVideoAction({
                                 channel_id: selectedChannelID,
                                 start_date: startDate,
                                 end_date: dayjs().format('YYYY-MM-DD')
                              })
                           )
                        }}>
                        <span>Last 6 Month</span>
                     </button>

                     <button
                        type="button"
                        className="channel-btn"
                        disabled={fetchVideoLoading}
                        onClick={() => {
                           const startDate = calculateDate('1Year')
                           dispatch(
                              fetchNewVideoAction({
                                 channel_id: selectedChannelID,
                                 start_date: startDate,
                                 end_date: dayjs().format('YYYY-MM-DD')
                              })
                           )
                        }}>
                        <span>Last 1 Year</span>
                     </button>
                  </div>
                  <div className="row">
                     <div className="col-12 fetch-date-select mb-2 ">
                        <label className="at-text-dark mb-1">Start Date</label>
                        <DatePicker
                           selected={startDate}
                           onChange={(date) => {
                              if (date) {
                                 setStartDate(date)
                                 setValue('start_date', dayjs(date).format('YYYY-MM-DD'))
                                 clearErrors('start_date')
                              } else {
                                 setStartDate(null)
                                 setValue('start_date', null)
                                 setError('start_date', { message: 'Please select start date.' })
                              }
                           }}
                           selectsStart
                           startDate={startDate}
                           endDate={endDate}
                           maxDate={new Date()}
                           dateFormat={'YYYY-MM-dd'}
                           placeholderText="YYYY-MM-DD"
                           className={`form-control at-text-box ${
                              errors?.start_date ? 'error' : ''
                           }`}
                        />
                        <span className="error-text">
                           <ErrorMessage
                              errors={errors}
                              name="start_date"
                              message={errors?.start_date?.message}
                           />
                        </span>
                     </div>
                     <div className="col-12 fetch-date-select mb-2 ">
                        <label className="at-text-dark mb-1">End Date</label>
                        <DatePicker
                           selected={endDate}
                           onChange={(date) => {
                              if (date) {
                                 setEndDate(date)
                                 setValue('end_date', dayjs(date).format('YYYY-MM-DD'))
                                 clearErrors('end_date')
                              } else {
                                 setEndDate(null)
                                 setValue('end_date', null)
                                 setError('end_date', { message: 'Please select end date.' })
                              }
                           }}
                           selectsEnd
                           startDate={startDate}
                           endDate={endDate}
                           minDate={startDate}
                           maxDate={new Date()}
                           dateFormat={'YYYY-MM-dd'}
                           placeholderText="YYYY-MM-DD"
                           className={`form-control at-text-box ${errors?.end_date ? 'error' : ''}`}
                        />
                        <span className="error-text">
                           <ErrorMessage
                              errors={errors}
                              name="end_date"
                              message={errors?.end_date?.message}
                           />
                        </span>
                     </div>
                  </div>
                  {fetchVideoLoading ? (
                     <button type="button" disabled={fetchVideoLoading} className="at-btn">
                        Loading...
                     </button>
                  ) : (
                     <button className="at-btn" onClick={handleSubmit(onSubmit)}>
                        Fetch Video
                     </button>
                  )}
               </form>
            </div>
         </CustomModal>
      </div>
   )
}

export default FetchNewVideo
